import React, { FC, useRef, useState } from 'react';
import MainBox from 'src/components/molecules/contentLayout/MainBox';
import TitleContent from 'src/components/molecules/contentLayout/TitleContent';
import { alertModalViewStore, confirmModalViewStore } from 'src/store/modal';
import IncomeDetail from 'src/components/molecules/table/IncomeDetail';
// import TobeInfo from '../TobeInfo';
import { contentModalViewStore } from 'src/store/modal';
import TotalPayment from './TotalPayment';
import OutPayment from './OutPayment';
import TaxReceipt from './TaxReceipt';
import '../../style.scss';
import './style.scss';

interface Props {
  num: number;
}

const StepE: FC<Props> = ({ num }) => {
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const setContentModalState = contentModalViewStore((state: any) => state.set);
  const setAlertModalState = alertModalViewStore(state => state.set);
  const closeEvt = () => {
    setAlertModalState({ data: {}, active: '' });
  };

  const saveEvt = () => {
    const confirmDiv = () => {
      return (
        <div className="_confirm_modal_content">
          <div className="_title">관리자 저장완료</div>
          {/* <div className="_import">BBBB</div> */}
        </div>
      );
    };

    setAlertModalState({
      data: {
        mainTitle: '관리자 확정 완료',
        subTitle: '',
      },
      active: '_active',
    });
  };
  const detailViewEvt = () => {
    const payload = {
      active: '_active',
      title: '연말정산 상세 내역',
      content: <IncomeDetail type="list" data={[]} />,
      styleDef: { width: '1024px' },
    };
    setContentModalState(payload);
  };

  const middleContent = () => {
    return (
      <div className="_temp_content_layout">
        <div className="_info_step">
          <section className="_section_layout _t1">
            <TotalPayment data={{}} confirmEvent={saveEvt} detailViewEvent={detailViewEvt} />
          </section>
          <section className="_section_layout _t3">
            <TitleContent
              label="연말정산 결과 출력"
              desc="연말정산 결과 출력물(PDF)을 확인 할 수 있습니다."
              content={<OutPayment data={{}} />}
            />
          </section>
          <section className="_section_layout">
            <TitleContent
              label="원천징수 영수증"
              desc="원천징수 영수증 결과를 확인합니다."
              content={<TaxReceipt data={{}} />}
            />
          </section>
        </div>
      </div>
    );
  };
  return (
    <div className="_step_layout">
      <MainBox
        label="연말정산 결과"
        content={middleContent()}
        num={num}
        icon="ri-article-line"
        desc=<div>
          본 결과는 제출한 자료를 기준으로 산출된 예상 연말정산 결과입니다. <br />
          제출서류 검토 및 세법 적용 결과에 따라 최종 환급세액 또는 추가 납부세액이 변경될 수
          있으며, 최종 확정 금액은 급여 지급 시 반영됩니다.
        </div>
        confitmEvent={saveEvt}
      />
    </div>
  );
};

export default StepE;
